/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unclog_Change_BodyInputs */



/**
* | output |
* | --- |
* | "Unclog / Replace valve body" |
*
* @param {Unclog_Change_BodyInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const unclog_change_body = /** @type {((inputs?: Unclog_Change_BodyInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unclog_Change_BodyInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Unclog / Replace valve body")
	return /** @type {LocalizedString} */ ("Dégripper / Changer corps de vanne")
});